// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"105":"dict","177":"home","443":"about"}[chunkId] + "." + {"105":"662194b2","177":"3699cc33","443":"c9449d98"}[chunkId] + ".css";
};